export const APP_ACTION__GET = 'APP_ACTION__GET';
export const APP_ACTION__GET_SUCCESS = 'APP_ACTION__GET_SUCCESS';
export const APP_ACTION__NEW_INCIDENT = 'APP_ACTION__NEW_INCIDENT';
export const APP_ACTION__NEW_INCIDENT_CONSUMED = 'APP_ACTION__NEW_INCIDENT_CONSUMED';
